import { Config } from '@/types/config';

let config: Partial<Config> = {};

try {
    if (process.env.NODE_ENV === 'production') {
        config = require('@/config/config.json');
    } else {
        config = require('@/config/dev.json');
    }
// eslint-disable-next-line no-empty
} catch (ignore) {}

export function createConfig (additional: Partial<Config> = {}, index: number): Config {
    return new Config({
        index,
        ...additional,
        ...config,
        initParams: {
            ...(config.initParams || {}),
            ...(additional.initParams || {}),
        },
    });
}
